module.exports = __webpack_public_path__ + "static/media/icon-email.98bf76b1.svg";